// extracted by mini-css-extract-plugin
module.exports = {"tips":"tips-add_tips_2OsFE"};